/**
 * Google cloud storage folders.
 * This file cannot create a static path because each file uploaded will have a unique ID at the end,
 * this is done for the purpose of effective caching. Meaning no 2 files uploaded will have the same path.
 *
 * All folders like profile pictures are plural because each time the user uploads a picture a new one will be uploaded, and the old one will be left as is.
 */

import { AttachmentKey, EmailKey, MailboxKey, OrgKey, UserKey } from "../models/base/Keys";

const userFolder = (args: UserKey) => {
  return `users/${args.uid}`;
};

const orgsFolder = (args: OrgKey) => {
  return `orgs/${args.orgId}`;
};

const profilePictures = (args: UserKey) => {
  return `${userFolder(args)}/profile_pictures`;
};

const orgLogos = (args: OrgKey) => {
  return `${orgsFolder(args)}/logos`;
};

const mailboxFolder = (args: MailboxKey) => {
  return `${orgsFolder(args)}/mailboxes/${args.uid}`;
};

const inboundFolder = (args: EmailKey) => {
  return `${mailboxFolder(args)}/inbound/${args.emailId}`;
};

const inboundAttachmentPath = (args: AttachmentKey) => {
  return `${inboundFolder(args)}/attachment/${args.attachmentId}`;
};

const inboundInlineAttachmentPath = (args: AttachmentKey) => {
  return `${inboundFolder(args)}/inline_attachment/${args.attachmentId}`;
};

const inboundEmailTextContentPath = (args: EmailKey) => {
  return `${inboundFolder(args)}/text_content.txt`;
};

const inboundEmailHtmlContentPath = (args: EmailKey) => {
  return `${inboundFolder(args)}/html_content.html`;
};

const outboundFolder = (args: EmailKey) => {
  return `${mailboxFolder(args)}/outbound/${args.emailId}`;
};

const outboundAttachmentPath = (args: AttachmentKey) => {
  return `${outboundFolder(args)}/attachment/${args.attachmentId}`;
};

const outboundInlineAttachmentPath = (args: AttachmentKey) => {
  return `${outboundFolder(args)}/inline_attachment/${args.attachmentId}`;
};

const outboundEmailTextContentPath = (args: EmailKey) => {
  return `${outboundFolder(args)}/text_content.txt`;
};

const outboundEmailHtmlContentPath = (args: EmailKey) => {
  return `${outboundFolder(args)}/html_content.html`;
};

export const gcsPaths = {
  profilePictures,
  orgLogos,
  mailboxFolder,
  inboundFolder,
  outboundFolder,
  inboundAttachmentPath,
  inboundInlineAttachmentPath,
  inboundEmailTextContentPath,
  inboundEmailHtmlContentPath,
  outboundAttachmentPath,
  outboundInlineAttachmentPath,
  outboundEmailTextContentPath,
  outboundEmailHtmlContentPath,
};
